<template>
    <div>
        <AddPlayer v-on:players-add-player="PlayersAddPlayer" ></AddPlayer>
    </div>
</template>

<script>
    import AddPlayer from "./AddPlayer";
    export default {
        name: "Inventory",
        components: {
            AddPlayer,
        },
        methods:{
            PlayersAddPlayer: function (aPlayer) {
                // On passe au niveau suivant
                this.$emit('players-add-player', aPlayer);
            },
        },
    }
</script>

<style scoped>

</style>